import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Sessao} from '../../../shared/model/sessao/sessao.model';
import {CardSessaoMobileComponent} from '../utils/card-sessao-mobile/card-sessao-mobile.component';
import {TituloRotinaComponent} from '../../../shared/components/app-titulo/titulo-component';
import {ButtonPadraoComponent} from '../../../shared/components/button-padrao/button-padrao.component';
import {FormFieldComponent} from '../../../shared/components/form-field/form-field.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltip} from '@angular/material/tooltip';
import {debounceTime} from 'rxjs';
import {MatIcon} from '@angular/material/icon';
import {TabelaSkeletonComponent} from '../../../shared/components/tabela-skeleton/tabela-skeleton.component';
import {
  CardMobileSkeletonComponent
} from '../../../shared/components/card-mobile-skeleton/card-mobile-skeleton.component';
import {CardSessaoTabletComponent} from '../utils/card-sessao-tablet/card-sessao-tablet.component';

@Component({
  selector: 'app-sessao-mobile',
  standalone: true,
  imports: [
    CardSessaoMobileComponent,
    TituloRotinaComponent,
    ButtonPadraoComponent,
    FormFieldComponent,
    FormsModule,
    MatTooltip,
    ReactiveFormsModule,
    MatIcon,
    TabelaSkeletonComponent,
    CardMobileSkeletonComponent,
    CardSessaoTabletComponent
  ],
  templateUrl: './sessao-mobile.component.html',
  styleUrl: './sessao-mobile.component.css'
})
export class SessaoMobileComponent implements OnInit {

  @Input() sessoes: Sessao[] = [];
  @Input() carregando = false;
  @Input() larguraTela?: number;
  @Output() modalFritoEmit = new EventEmitter<boolean>();
  @Output() filtrosEmit = new EventEmitter<boolean>();
  @Output() nomeBuscadoEmit = new EventEmitter<string>();
  @Output() exibirDetalhes = new EventEmitter<Sessao>();
  @Output() modalChat = new EventEmitter<Sessao>();
  @Output() edicaoDetalhes = new EventEmitter<Sessao>();
  @Output() reiniciarSessao = new EventEmitter<Sessao>();


  btnBuscaAcionado = false;

  formSessao: FormGroup;

  private readonly destroyRef = inject(DestroyRef);
  private readonly fb = inject(FormBuilder);

  constructor() {
    this.formSessao = this.fb.group({
      numNome: ['']
    });
  }

  ngOnInit() {
    this.configurarDebounce();
  }


  abrirModalFiltro(){
    this.modalFritoEmit.emit(true);
  }

  iniciarFiltros(){
    this.filtrosEmit.emit(true);
  }

  configurarDebounce(): void {
    this.formSessao.get('numNome')!.valueChanges.pipe(
      debounceTime(300),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(value => this.filtrarPorNome(value));
  }

  filtrarPorNome(nome: string): void {
    this.nomeBuscadoEmit.emit(nome);
  }

}
